// import React, { createContext, useState, useContext, useEffect } from "react";

// // Create the authentication context
// export const AuthContext = createContext(null);

// // Auth provider component
// export const AuthProvider = ({ children }) => {
//   const [currentUser, setCurrentUser] = useState(null);
//   const [userID, setUserID] = useState(null);
//   const [userRole, setUserRole] = useState(null);
//   const [JWT, setJWT] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Check if user is logged in when the component mounts
//     const checkUserStatus = () => {
//       const defaultUser = { user: "guest" };

//       const storedUser = localStorage.getItem("user");
//       const storedRole = localStorage.getItem("userRole");
//       const storedJWT = localStorage.getItem("JWToken");
//       const storedUserID = localStorage.getItem("userID");

//       console.log(storedUser, storedRole);

//       console.log(storedUser !== "undefined" ? storedUser : defaultUser);
//       const parsedUser = storedUser !== "undefined" ? storedUser : defaultUser;
//       const parsedUserID = storedUserID !== "undefined" ? storedUserID : null;
//       const parsedToken = storedJWT !== "undefined" ? storedJWT : null;
//       const parsedRole = storedRole || "guest";
//       setCurrentUser(parsedUser);
//       setUserID(parsedUserID);
//       setUserRole(parsedRole);
//       setJWT(parsedToken);
//       setLoading(false);
//     };
//     checkUserStatus();
//   }, []);

//   // Login function
//   const login = (user, role, jwt, userID) => {
//     console.log(user, role, "okokokok");

//     localStorage.setItem("user", user);
//     localStorage.setItem("userRole", role);
//     localStorage.setItem("JWToken", jwt);
//     localStorage.setItem("userID", userID);

//     setCurrentUser(user);
//     setUserID(userID);
//     setUserRole(role);
//     setJWT(jwt);
//   };
//   // Logout function
//   const logout = () => {

//     localStorage.removeItem("user");
//     localStorage.removeItem("userRole");
//     localStorage.removeItem("JWToken");
//     localStorage.removeItem("userID");
//     setCurrentUser(null);
//     setUserID(null);
//     setUserRole(null);
//     setJWT(null);
//   };

//   const value = {
//     currentUser,
//     userID,
//     userRole,
//     login,
//     logout,
//     isAdmin: userRole === "super_admin",
//     isVendor: userRole === "vendor",
//     isTeacher: userRole === "teacher",
//     isCollege: userRole === "college_admin",
//     isStudent: userRole === "student",
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {!loading && children}
//     </AuthContext.Provider>
//   );
// };

// // Custom hook to use the auth context
// export const useAuth = () => {
//   return useContext(AuthContext);
// };










import React, { createContext, useState, useContext, useEffect, useRef } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useMutation } from "react-query";
import api from "../utils/helper";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userID, setUserID] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [JWT, setJWT] = useState(null);
  const [loading, setLoading] = useState(true);

  const timeSpentRef = useRef(0);
  const intervalRef = useRef(null);
  const shouldTrack = useRef(false);

  // Session mutation
  const sessionMutation = useMutation((sessionData) => {
    return api.post("/session/send-session", sessionData);
  });


  // 🟡 Idle detection
  useIdleTimer({
    timeout: 1000 * 60 * 5, // 5 minutes
    onIdle: () => clearInterval(intervalRef.current),
    onActive: () => {
      if (shouldTrack.current) {
        startTimer();
      }
    },
    debounce: 500,
  });

  // ✅ Start timer
  const startTimer = () => {

    clearInterval(intervalRef.current); // avoid multiple intervals
    intervalRef.current = setInterval(() => {
      timeSpentRef.current += 1; // 1 second
    }, 1000);
  };

  // ✅ Stop timer and send data

  const stopAndSendSession = () => {

    console.log("call 2", timeSpentRef.current)
    clearInterval(intervalRef.current);

    if (timeSpentRef.current > 0 && userID) {
      const sessionData = {

        timeSpent: timeSpentRef.current,
      };

      console.log(sessionData, "Session stopped");

      // Use the mutation's promise and return it
      return sessionMutation.mutateAsync(sessionData)
        .then(response => {
          console.log("Session data saved successfully", response);
          // Reset for next session
          timeSpentRef.current = 0;

          // Still use sendBeacon as backup
          navigator.sendBeacon(
            "/api/session-log",
            JSON.stringify(sessionData)
          );

          return response;
        })
        .catch(error => {
          console.error("Failed to save session data", error);

          // Still use sendBeacon as backup
          navigator.sendBeacon(
            "/api/session-log",
            JSON.stringify(sessionData)
          );

          // Reset for next session
          timeSpentRef.current = 0;

          // Re-throw the error if you want to handle it in the calling function
          // or resolve with null to continue logout process regardless of error
          return null;
        });
    }

    // If no time spent or no userID, return a resolved promise
    return Promise.resolve();
  };



  // 🔴 On browser/tab close
  useEffect(() => {
    const handleUnload = () => stopAndSendSession();
    window.addEventListener("beforeunload", handleUnload);
    return () => window.removeEventListener("beforeunload", handleUnload);
  }, [userID]);

  // 🟢 On mount: restore session
  useEffect(() => {
    const defaultUser = { user: "guest" };

    const storedUser = localStorage.getItem("user");
    const storedRole = localStorage.getItem("userRole");
    const storedJWT = localStorage.getItem("JWToken");
    const storedUserID = localStorage.getItem("userID");

    const parsedUser = storedUser !== "undefined" ? storedUser : defaultUser;
    const parsedUserID = storedUserID !== "undefined" ? storedUserID : null;
    const parsedToken = storedJWT !== "undefined" ? storedJWT : null;
    const parsedRole = storedRole || "guest";

    setCurrentUser(parsedUser);
    setUserID(parsedUserID);
    setUserRole(parsedRole);
    setJWT(parsedToken);
    setLoading(false);
  }, []);

  // ✅ LOGIN FUNCTION
  const login = (user, role, jwt, userID) => {
    localStorage.setItem("user", user);
    localStorage.setItem("userRole", role);
    localStorage.setItem("JWToken", jwt);
    localStorage.setItem("userID", userID);

    setCurrentUser(user);
    setUserID(userID);
    setUserRole(role);
    setJWT(jwt);

    shouldTrack.current = true;
    startTimer();
  };

  // ✅ LOGOUT FUNCTION

  const logout = async () => {
    try {
      // Wait for the session data to be saved
      await stopAndSendSession();

      // After session data is saved, clear user data
      localStorage.removeItem("user");
      localStorage.removeItem("userRole");
      localStorage.removeItem("JWToken");
      localStorage.removeItem("userID");

      setCurrentUser(null);
      setUserID(null);
      setUserRole(null);
      setJWT(null);

      shouldTrack.current = false;

      console.log("Logout completed successfully");
    } catch (error) {
      console.error("Error during logout process", error);

      // Still logout even if there was an error saving session
      localStorage.removeItem("user");
      localStorage.removeItem("userRole");
      localStorage.removeItem("JWToken");
      localStorage.removeItem("userID");

      setCurrentUser(null);
      setUserID(null);
      setUserRole(null);
      setJWT(null);

      shouldTrack.current = false;
    }
  };

  const endSession = async () => {
    console.log("function call")
    await stopAndSendSession();
  };


  const value = {
    currentUser,
    userID,
    userRole,
    login,
    logout,
    startTimer,
    endSession,
    isAdmin: userRole === "super_admin",
    isVendor: userRole === "vendor",
    isTeacher: userRole === "teacher",
    isCollege: userRole === "college_admin",
    isStudent: userRole === "student",
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
